"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    onClickTrigger: _propTypes.func,
    style: _propTypes.object,
    stopPosition: _propTypes.number,
    isSmooth: _propTypes.bool,
    theme: _propTypes.string,
    icon: _propTypes.string,
    fontsize: _propTypes.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    onClickTrigger: function onClickTrigger() {},
    style: {},
    stopPosition: 0,
    isSmooth: true,
    icon: 'ArrowUp',
    fontsize: 'XSmall'
  }
};
exports.default = _default;